import React, { useMemo, useState } from "react";
import CumulativeProgressionChart, { buildDatasetSeries } from "../VoteCharts/CumulativeProgressionChart";
import { getPlayerRoundsByDataset } from "./playerRoundVotes";

/**
 * Season progression for a single player: one line per enabled dataset plus the
 * consensus average, so the spread shows how much the sources disagree.
 */
const PlayerVoteProgressionChart = ({ player, gameVoteData, enabledKeys = [] }) => {
  // enabledKeys is rebuilt on every render, so key the memo on its contents.
  const enabledKey = enabledKeys.join(',');

  const series = useMemo(
    () => buildDatasetSeries(getPlayerRoundsByDataset(player, gameVoteData, enabledKeys)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [player, gameVoteData, enabledKey]
  );

  const [hoverSeries, setHoverSeries] = useState(null);

  if (!player || !gameVoteData || !series.length) return null;

  return (
    <div className="bg-slate-950/60 rounded-xl border border-slate-800 p-3 sm:p-4">
      <CumulativeProgressionChart
        series={series}
        consensusIndex={0}
        hoverSeries={hoverSeries}
        onHoverSeries={setHoverSeries}
        ariaLabel="Cumulative player votes by round, per dataset"
      />
    </div>
  );
};

export default PlayerVoteProgressionChart;
